// extracted by mini-css-extract-plugin
export var externalLink = "_82-0";
export var internalLinkLabel = "_82-1";